/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:00d2a0a1-b224-455f-8c8a-939fb9a0faec",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_5QUAdX6qq",
    "aws_user_pools_web_client_id": "heeps5knddccils8jjl00anhl",
    "oauth": {
        "domain": "machwerkmaintainanceapp-prod.auth.eu-central-1.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://localhost:3000/",
        "redirectSignOut": "https://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://r63pq1m12d.execute-api.eu-central-1.amazonaws.com/prod",
            "region": "eu-central-1"
        },
        {
            "name": "UserQueries",
            "endpoint": "https://bb6opfz8qi.execute-api.eu-central-1.amazonaws.com/prod",
            "region": "eu-central-1"
        }
    ],
    "aws_user_files_s3_bucket": "machwerktaskimages25130-prod",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
